import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const MOBILE_MAX_WIDTH = 768;

/** Paths allowed on mobile: public-facing pages that anyone may scan to. */
const isAllowedOnMobile = (pathname: string) =>
  pathname.startsWith("/verify-compliance") ||
  /^\/certificate\/[^/]+$/.test(pathname);

export default function MobileAwareRoot() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const update = () => setIsMobile(mql.matches);
    update();
    mql.addEventListener("change", update);
    return () => mql.removeEventListener("change", update);
  }, []);

  if (isMobile && !isAllowedOnMobile(location.pathname)) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-off-white p-6 text-center">
        <div className="max-w-md flex flex-col gap-4">
          <img
            src="/assets/icons/round-cancel.svg"
            alt=""
            className="w-16 h-16 mx-auto opacity-80"
            aria-hidden
          />
          <h1 className="font-clash-display text-xl font-semibold text-medium-dark-grey">
            Mobile view not supported
          </h1>
          <p className="font-clash-display text-sm font-regular text-medium-dark-grey leading-relaxed">
            This site is not available on mobile phones. Please open it on your
            tablet or desktop to continue.
          </p>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
